import React from 'react';
import i18n from '../../utilities/i18n';
import { VStack, FilterButton, Popup } from '@adc/parallax-component-library';
import { IconFilter } from '@adc/parallax-icons';
import CheckboxFilterList from './filters/CheckboxFilterList';
import { CheckboxFilterSection, CheckboxFilterItem } from './DynamicTable';

interface TableFiltersProps {
  enableFiltering: boolean;
  checkboxFilters: CheckboxFilterSection[];
  isFilterPopupOpen: boolean;
  setIsFilterPopupOpen: (open: boolean) => void;
  activeFiltersCount: number;
  onFilterChange: (
    sectionId: CheckboxFilterSection['id'],
    item: CheckboxFilterItem,
  ) => void;
  onResetFilters: () => void;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  enableFiltering,
  checkboxFilters,
  isFilterPopupOpen,
  setIsFilterPopupOpen,
  activeFiltersCount,
  onFilterChange,
  onResetFilters,
}) => {
  if (!enableFiltering || !checkboxFilters?.length) {
    return null;
  }

  return (
    <Popup
      // @ts-expect-error Parallax Popup types are incorrect
      title={i18n.t('Filters.title')}
      headerExtra={{
        label: i18n.t('Filters.clearAll'),
        onPress: onResetFilters,
      }}
      content={
        <VStack
          justifyContent="center"
          alignItems="flex-start"
          minWidth={250}
          gap={'$2'}
        >
          {checkboxFilters.map((checkboxFilter, index) => (
            <CheckboxFilterList
              key={index}
              id={checkboxFilter.id}
              label={checkboxFilter.label}
              items={checkboxFilter.items}
              onChange={onFilterChange}
            />
          ))}
        </VStack>
      }
      contentPadding={true}
      open={isFilterPopupOpen}
      placement="bottom-end"
    >
      <FilterButton
        testID="table-filters-button"
        iconStart={<IconFilter />}
        label={i18n.t('Filters.title')}
        badge={activeFiltersCount > 0 ? activeFiltersCount : undefined}
        selected={isFilterPopupOpen}
        onPress={() => setIsFilterPopupOpen(!isFilterPopupOpen)}
      />
    </Popup>
  );
};
